<template>
  <div class="keyboard px">
    <c-keyboard-magnetic
      class="c-keyboard"
      :layer="layer"
      :layerIndex="layerIndex"
      :selectedIndex="selectedIndex"
      @key-click="onKeyClick"
    />
    <div class="info">
      <div class="buttons">
        <div class="button" @click="onDisable">
          {{ $t("mouse.disable") }}
        </div>
        <div class="button" @click="onRestore">
          {{ $t("mouse.restore") }}
        </div>
        <div class="button" @click="onSure">
          {{ $t("mouse.sure") }}
        </div>
      </div>
    </div>
    <div class="reset" @click="onReset">
      <a-icon class="icon" type="redo" :rotate="270" /> {{ $t("reset") }}
    </div>
    <div class="panels">
      <div class="panel">
        <div class="panel-content"></div>
      </div>
      <div class="panel">
        <div class="panel-content"></div>
      </div>
      <div class="panel">
        <div class="panel-content"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { download } from "@/utils";

export default {
  data() {
    return {
      activeKey: "0x00",
      selectedKey: "0x00",
      selectedMacroIndex: -1,
      macroList: [
        {
          index: 1,
          profile: 0,
          key_code: "",
          repeat: 1,
          playModel: "",
          macroValue: {
            keyOrder: [],
            pressTime: [],
          },
        },
      ],
      playModel: "0x00",
      repeat: 1,
      layerIndex: 0,
      selectedIndex: -2,
      selectedKeyIndex: null,
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("app", {
      isCN: "isCN",
    }),
    ...mapState("loader", {
      inLoader: "inLoader",
      systemInfo: "systemInfo",
      currentDevice: "currentDevice",
    }),
    ...mapState(["profile75"]),
    layer() {
      return this.profile75.data.key_layer.layer_data[this.layerIndex].layer;
    },
    layerNum() {
      return this.profile75.data.key_layer.layer_num;
    },
  },
  methods: {
    onKeyClick() {},
    onDisable() {
      this.$store.dispatch("loader/changeMouseKey", {
        key_code: this.activeKey,
        change_key: ["0x00", "0x00", "0x00", "0x00"],
      });
    },
    onRestore() {
      const keymap = {
        "0x00": ["0x01", "0x00", "0xf0", "0x00"],
        "0x02": ["0x01", "0x00", "0xf2", "0x00"],
        "0x01": ["0x01", "0x00", "0xf1", "0x00"],
        "0x0e": ["0x01", "0x00", "0xf5", "0x01"],
        "0x0f": ["0x01", "0x00", "0xf5", "0xff"],
        "0x03": ["0x01", "0x00", "0xf3", "0x00"],
        "0x04": ["0x01", "0x00", "0xf4", "0x00"],
      };
      this.$store.dispatch("loader/changeMouseKey", {
        key_code: this.activeKey,
        change_key: keymap[this.activeKey],
      });
    },
    onSure() {
      if (this.selectedMacroIndex > -1) {
        let macro = this.macroList.find(
          (i) => i.index === this.selectedMacroIndex
        );
        macro.key_code = this.activeKey;
        macro.repeat = parseInt(this.repeat);
        macro.playModel = this.playModel;
        macro.change_key = [
          "0x09",
          this.playModel,
          `0x${macro.index.toString(16).padStart(2, "0")}`,
          "0x00",
        ];
        this.$store.dispatch("loader/setMouseMacro", macro).then(() => {
          this.$message.info(this.$t("loader.saveSuccess"));
        });
      } else {
        this.$store
          .dispatch("loader/changeMouseKey", {
            key_code: this.activeKey,
            change_key: this.selectedKey,
          })
          .then(() => {
            this.$message.info(this.$t("loader.saveSuccess"));
          });
      }
    },
    onReset() {
      this.$store.dispatch("loader/resetMagnetKey");
      // this.$confirm({
      //   title: this.$t("loader.transport"),
      //   okText: this.$t("yes"),
      //   cancelText: this.$t("cancel"),
      //   centered: true,
      //   onOk: () => {
      //     this.$store.dispatch("loader/transportMode");
      //   },
      // });
    },
  },
  watch: {
    activeKey() {
      this.selectedKey = "0x00";
      this.selectedMacroIndex = -1;
    },
    selectedKey() {
      this.selectedKey != "0x00" && (this.selectedMacroIndex = -1);
    },
    selectedMacroIndex() {
      this.selectedMacroIndex != -1 && (this.selectedKey = "0x00");
    },
  },
  mounted() {
    // this.$store.dispatch("loader/getMouseMacro");
    // window.initMouseMacros = (json) => {
    //   if (json) {
    //     console.log("initMouseMacros", json);
    //     const data = JSON.parse(json);
    //     this.macroList = data.mouseMacroData;
    //     console.log("initMouseMacros", "true");
    //   }
    // };
  },
};
</script>
<style lang="scss" scoped>
.keyboard {
  font-size: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 150px;
  background: #000000;

  .info {
    @include flex-center;
    width: 1200px;

    .list {
      width: 400px;
      height: 400px;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      align-items: flex-start;

      .item {
        @include flex-center;
        margin-bottom: 60px;
        font-size: 21px;

        .no {
          @include flex-center;
          width: 30px;
          height: 30px;
          border: 1px solid #ffffff;
          margin-right: 8px;
          border-radius: 5px;
          font-size: 18px;
        }
      }
    }

    .keys {
      visibility: hidden;
      width: 400px;
      height: 400px;
      background: url("../../assets/images/device_mouse.png") center / auto 100%
        no-repeat;
      position: relative;

      .key {
        @include flex-center;
        width: 35px;
        height: 35px;
        position: absolute;
        background-color: $active-color;
        border-radius: 50%;
        cursor: pointer;

        &:hover,
        &.active {
          background-color: $primary-color;
        }
      }

      .key1 {
        top: 16%;
        left: 33%;
      }

      .key2 {
        top: 16%;
        left: 45.8%;
      }

      .key3 {
        top: 16%;
        left: 58%;
      }

      .key4 {
        top: 4%;
        left: 45.8%;
      }

      .key5 {
        top: 28%;
        left: 45.8%;
      }

      .key6 {
        top: 33%;
        left: 12%;
      }

      .key7 {
        top: 48%;
        left: 12%;
      }
    }

    .buttons {
      @include flex-center;
      width: 400px;
      height: 400px;
      visibility: hidden;

      .button {
        @include button;
        width: 120px;
        height: 34px;
        margin: 10px;
      }
    }
  }

  .reset {
    font-size: 24px;
    padding: 5px 10px;
    margin-left: 1100px;
    margin-bottom: 40px;
    cursor: pointer;

    .icon {
      color: $active-color;
      font-weight: bolder;
    }

    &:hover {
      color: $active-color;
    }
  }

  .panels {
    @include flex-center;
    width: 1200px;
    justify-content: flex-start;
  }

  .panel {
    width: 320px;
    height: 300px;
    background-image: linear-gradient(270deg, #ee92ff 0%, #42bfe9 100%);
    box-shadow: 0 0 20px 0 #4136f1;
    border-radius: 15px;
    padding: 3px;
    margin-right: 30px;

    .panel-content {
      width: 100%;
      height: 100%;
      padding: 5px 15px;
      background-color: #000000;
      border-radius: 15px;

      .title {
        font-size: 22px;
        line-height: 50px;
        height: 50px;
        padding-left: 38px;
      }
    }

    .radio-group {
      width: 100%;
      height: calc(100% - 120px);
      overflow-y: scroll;

      &::-webkit-scrollbar {
        width: 10px;
      }

      .radio {
        @include flex-center;
        height: 50px;
        line-height: 50px;
        justify-content: flex-start;
        font-size: 20px;

        &.ant-radio-wrapper-checked,
        &:hover {
          color: #ffffff;
        }

        .ant-radio .ant-radio-inner {
          border-color: $active-color;
          color: $active-color;
        }
      }
    }

    .play-model {
      @include flex-center;
      height: 60px;
      color: #ffffff;

      .radio {
        @include flex-center;
        justify-content: flex-start;

        .ant-radio .ant-radio-inner {
          border-color: $active-color;
          color: $active-color;
        }
      }
    }
  }
}
</style>

<style lang="scss">
.keyboard {
  .panel {
    .radio-group .radio {
      .ant-radio .ant-radio-inner {
        border-color: $active-color;

        &::after {
          background-color: $active-color;
        }
      }
    }

    .play-model .radio {
      .ant-radio {
        margin-right: 5px;
      }

      span:not(.ant-radio) {
        padding: 0;
        @include flex-center;
        font-size: 16px;
        color: #ffffff;
      }
    }

    .repeat {
      width: 70px;
      margin-left: 5px;
      font-size: 14px;
    }
  }
}
</style>
